(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vh-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFrame(frame) {
    if (frame.dataset.vhBaReady === '1') return;
    frame.dataset.vhBaReady = '1';

    var range = frame.querySelector('.vh-ba__range');

    function setPos(p) {
      p = Math.max(0, Math.min(100, p));
      frame.style.setProperty('--vh-ba-pos', p + '%');
    }

    function posFromX(clientX) {
      var rect = frame.getBoundingClientRect();
      if (!rect.width) return 50;
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function apply(clientX) {
      var p = Math.max(0, Math.min(100, posFromX(clientX)));
      if (range) range.value = p;
      setPos(p);
    }

    if (range) {
      range.addEventListener('input', function () {
        setPos(parseFloat(range.value));
      });
      setPos(parseFloat(range.value) || 50);
    }

    var dragging = false;

    frame.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (frame.setPointerCapture) {
        try { frame.setPointerCapture(e.pointerId); } catch (err) {}
      }
      apply(e.clientX);
      e.preventDefault();
    });

    frame.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      apply(e.clientX);
    });

    function stop() { dragging = false; }
    frame.addEventListener('pointerup', stop);
    frame.addEventListener('pointercancel', stop);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.vh-ba__frame').forEach(initFrame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-kol-videos"] && !Shopify.designMode) return;
  try {
    
  class VhKolVideos extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-vh-kol-track]');
      if (!this.track || this.bound) return;
      this.bound = true;

      this.prev = this.querySelector('[data-vh-kol-prev]');
      this.next = this.querySelector('[data-vh-kol-next]');

      this.bindTrack();
      this.bindCards();
    }

    disconnectedCallback() {
      this.closeModal();
    }

    /* ---------------------------------------------------------------- track */

    bindTrack() {
      const updateNav = () => {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
        if (this.prev) this.prev.hidden = this.track.scrollLeft <= 0;
        if (this.next) this.next.hidden = maxScroll <= 0 || this.track.scrollLeft >= maxScroll;
      };

      // An explicit clamped target rather than scrollBy: the end of the track is
      // then decided here instead of by whatever the browser does with an
      // overshooting relative scroll, so the last page always lands flush.
      const page = (direction) => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const target = Math.max(0, Math.min(max, this.track.scrollLeft + direction * this.pageDistance()));
        this.animateScroll(target);
      };

      if (this.prev) this.prev.addEventListener('click', () => page(-1));
      if (this.next) this.next.addEventListener('click', () => page(1));

      this.track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    // Scrolls the row to `target` over a short ease-out, one frame at a time.
    //
    // The tween is hand-rolled rather than handed to `behavior: 'smooth'` for
    // two reasons. A scroll-snap container fights an animated programmatic
    // scroll, so snapping has to be suspended for the duration either way — and
    // once it is suspended, assigning scrollLeft per frame is the predictable
    // way to move, with no reliance on the browser choosing to run its own
    // animation. Snap is restored at the end, on a card boundary, so it has
    // nothing to correct.
    //
    // A timer lands the row on the target regardless of whether frames arrive: a
    // background tab suspends requestAnimationFrame, and without the backstop a
    // suspended tween would strand the row wherever it stopped.
    animateScroll(target, duration = 380) {
      const start = this.track.scrollLeft;
      const delta = target - start;
      if (!delta) return;

      cancelAnimationFrame(this.raf);
      clearTimeout(this.snapTimer);
      this.track.style.scrollSnapType = 'none';

      const settle = () => {
        cancelAnimationFrame(this.raf);
        clearTimeout(this.snapTimer);
        this.track.scrollLeft = target;
        this.track.style.scrollSnapType = '';
      };

      const startedAt = performance.now();
      const ease = (t) => 1 - Math.pow(1 - t, 3);

      const frame = (now) => {
        const t = Math.min(1, (now - startedAt) / duration);
        if (t >= 1) return settle();
        this.track.scrollLeft = start + delta * ease(t);
        this.raf = requestAnimationFrame(frame);
      };

      this.raf = requestAnimationFrame(frame);
      this.snapTimer = setTimeout(settle, duration + 400);
    }

    // How far one arrow tap scrolls the row. Named for what it returns, and
    // deliberately not `step` — the lightbox has its own clip-to-clip stepper,
    // and when both were called `step` the later definition silently replaced
    // this one. The carousel then asked the lightbox for a distance, got
    // undefined, and scrolled to NaN — which the spec turns into 0. That is the
    // whole reason the arrows behaved like decoration.
    pageDistance() {
      const card = this.track.querySelector('.vh-kol__card');
      if (!card) return 300;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const cardStep = card.getBoundingClientRect().width + gap;

      // Every breakpoint now shows a whole number of cards per screenful — four
      // on a desktop, two on a phone — so an arrow always advances a full page
      // and the next set lands flush against both edges. Stepping one card at a
      // time, which is what desktop used to do, made a seven-clip row feel
      // stuck: the first tap shifted the strip by a fraction of a screen rather
      // than turning the page.
      //
      // +gap because the trailing card of a page has no gap after it, so a page
      // is one gap wider than the visible track.
      const perView = Math.max(1, Math.round((this.track.clientWidth + gap) / cardStep));
      return perView * cardStep;
    }

    /* ---------------------------------------------------------------- cards */

    bindCards() {
      const canHover = window.matchMedia('(hover: hover)').matches;

      this.querySelectorAll('[data-vh-kol-card]').forEach((card) => {
        const video = card.querySelector('video');
        const button = card.querySelector('[data-vh-kol-play]');
        if (!video) return;

        this.paintFirstFrame(video);

        // The bag is a real link out; a tap on it must not also open the modal.
        const bag = card.querySelector('[data-vh-kol-bag]');
        if (bag) bag.addEventListener('click', (event) => event.stopPropagation());

        const open = (event) => {
          if (event) event.preventDefault();
          this.openModal(card);
        };

        if (button) button.addEventListener('click', open);
        video.addEventListener('click', open);

        // Desktop keeps the silent hover preview. A tap on a touch device fires
        // no mouseenter, so phones go straight to the modal.
        if (canHover) {
          card.addEventListener('mouseenter', () => {
            video.muted = true;
            const played = video.play();
            if (played && played.catch) played.catch(() => {});
            card.classList.add('is-previewing');
          });

          card.addEventListener('mouseleave', () => {
            video.pause();
            video.currentTime = 0.001;
            card.classList.remove('is-previewing');
          });
        }
      });
    }

    // Belt and braces for the media fragment on the src. Some builds report
    // enough readyState to satisfy preload="metadata" without ever having
    // decoded a frame; assigning currentTime forces the seek that paints one.
    paintFirstFrame(video) {
      const nudge = () => {
        if (video.currentTime > 0) return;
        try {
          video.currentTime = 0.001;
        } catch (error) {
          /* seeking not ready yet — the loadeddata listener covers it */
        }
      };

      if (video.readyState >= 1) nudge();
      video.addEventListener('loadedmetadata', nudge, { once: true });
    }

    /* ---------------------------------------------------------------- modal */

    // Built on first use and parked on <body>. Kept out of the section subtree
    // because a position: fixed overlay is only reliably viewport-relative when
    // no ancestor has established a containing block with transform or filter.
    //
    // The chrome is all ours: the video is created with controls off. Handing
    // the bottom edge to the browser's control bar meant it fought the shop row
    // for the same strip, and its overlay buttons squatted on all four corners,
    // leaving nowhere safe for a close button. Owning the controls costs a
    // play/pause and a mute toggle and buys back the whole frame.
    ensureModal() {
      if (this.modal) return this.modal;

      const icon = (path, fill) =>
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="' + path + '" fill="' + (fill || 'none') + '" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      const modal = document.createElement('div');
      modal.className = 'vh-kol__modal';
      modal.hidden = true;
      modal.innerHTML = [
        '<div class="vh-kol__modal-backdrop" data-close></div>',

        '<button class="vh-kol__modal-close" type="button" data-close aria-label="Close">',
        icon('M6 6l12 12M18 6L6 18'),
        '</button>',

        '<div class="vh-kol__modal-inner" role="dialog" aria-modal="true">',
        '<div class="vh-kol__modal-stage" data-stage>',

        '<div class="vh-kol__modal-top">',
        '<span class="vh-kol__modal-creator" data-creator></span>',
        '<span class="vh-kol__modal-actions">',
        '<button class="vh-kol__modal-icon" type="button" data-mute aria-label="Mute"></button>',
        '<button class="vh-kol__modal-icon" type="button" data-share aria-label="Share">',
        icon('M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M12 15V3M8 7l4-4 4 4'),
        '</button>',
        '</span>',
        '</div>',

        '<button class="vh-kol__modal-playpause" type="button" data-playpause aria-label="Play">',
        icon('M8 5v14l11-7z', 'currentColor'),
        '</button>',

        '<div class="vh-kol__modal-shop" data-shop></div>',
        '<div class="vh-kol__modal-progress"><span data-progress></span></div>',

        '</div>',
        '</div>',

        '<button class="vh-kol__modal-step vh-kol__modal-step--prev" type="button" data-prev aria-label="Previous video">',
        icon('M6 15l6-6 6 6'),
        '</button>',
        '<button class="vh-kol__modal-step vh-kol__modal-step--next" type="button" data-next aria-label="Next video">',
        icon('M6 9l6 6 6-6'),
        '</button>',
      ].join('');

      modal.addEventListener('click', (event) => {
        if (event.target.closest('[data-close]')) return this.closeModal();
        if (event.target.closest('[data-prev]')) return this.stepClip(-1);
        if (event.target.closest('[data-next]')) return this.stepClip(1);
        if (event.target.closest('[data-mute]')) return this.toggleMute();
        if (event.target.closest('[data-share]')) return this.share();
        // A tap on the frame itself toggles playback. Products and the top bar
        // are excluded so tapping a card still follows its link.
        if (event.target.closest('[data-playpause]') || event.target.closest('video')) {
          this.togglePlay();
        }
      });

      // Bound here, once — not per open. This method hands back the same element
      // every launch, so wiring these in openModal() stacked a new set each
      // time. The stale ones stayed live, closed over the previous (discarded,
      // therefore paused) video, and every pointer move ran them: each cleared
      // the real hide timer and then declined to set a new one, which left the
      // chrome showing permanently from the second clip onwards.
      ['pointermove', 'pointerdown'].forEach((type) => {
        modal.addEventListener(type, () => this.wake());
      });
      // Safari on iOS still reports touches only through the touch events.
      modal.addEventListener('touchstart', () => this.wake(), { passive: true });

      document.body.appendChild(modal);
      this.modal = modal;
      return modal;
    }

    get video() {
      return this.modal ? this.modal.querySelector('.vh-kol__modal-video') : null;
    }

    // Desktop parks the close button out on the backdrop, clear of the clip.
    // A phone has no backdrop to spare — the clip runs nearly edge to edge, and
    // the top-left corner is where the creator's name sits — so there it joins
    // the mute and share buttons in the top-right row instead.
    //
    // The node is moved rather than positioned: the row lives inside the stage,
    // which clips its overflow, so a button placed there cannot be pushed back
    // out to the viewport corner with CSS. Two buttons sharing one job would
    // mean two things to keep in sync, so there is only ever the one.
    placeClose() {
      if (!this.modal) return;

      const close = this.modal.querySelector('.vh-kol__modal-close');
      const actions = this.modal.querySelector('.vh-kol__modal-actions');
      const host = window.matchMedia('(max-width: 749px)').matches ? actions : this.modal;

      if (close && close.parentElement !== host) host.appendChild(close);
    }

    // Activity wakes the chrome; it sleeps again after one idle second of
    // playback. A paused clip keeps its controls up, so the timer only ever
    // runs while something is playing. The video is looked up rather than
    // captured — this runs from listeners that outlive any single clip.
    wake() {
      if (!this.modal) return;

      const video = this.video;
      this.modal.classList.remove('is-idle');
      clearTimeout(this.idleTimer);

      if (video && !video.paused) {
        // Phones get longer: a tap is the only way to bring the chrome back, so
        // it should not vanish as fast as it does under a hovering mouse.
        const delay = window.matchMedia('(max-width: 749px)').matches ? 2000 : 1000;
        this.idleTimer = setTimeout(() => this.modal.classList.add('is-idle'), delay);
      }
    }

    togglePlay() {
      const video = this.video;
      if (!video) return;
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
      this.wake();
    }

    toggleMute() {
      const video = this.video;
      if (!video) return;
      video.muted = !video.muted;
      this.syncMute();
      this.wake();
    }

    syncMute() {
      const video = this.video;
      const button = this.modal.querySelector('[data-mute]');
      if (!video || !button) return;

      const on = 'M4 9v6h4l5 4V5L8 9H4zM16.5 8.5a5 5 0 0 1 0 7M19.5 6a8.5 8.5 0 0 1 0 12';
      const off = 'M4 9v6h4l5 4V5L8 9H4zM17 10l4 4M21 10l-4 4';
      button.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' +
        (video.muted ? off : on) +
        '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
    }

    share() {
      const card = this.cards && this.cards[this.index];
      const name = card ? card.dataset.vhKolName : '';
      const data = { title: name || document.title, url: window.location.href };

      if (navigator.share) {
        navigator.share(data).catch(() => {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(data.url).catch(() => {});
      }
      this.wake();
    }

    // Moves the lightbox from one clip to the next. Wraps around, so the last
    // clip's "next" returns to the first. See pageDistance() for why this is not
    // called `step`.
    stepClip(delta) {
      if (!this.cards || this.cards.length < 2) return;
      const next = (this.index + delta + this.cards.length) % this.cards.length;
      this.showCard(next);
      this.wake();
    }

    openModal(card) {
      this.cards = Array.from(this.querySelectorAll('[data-vh-kol-card]'));
      const index = this.cards.indexOf(card);
      if (index < 0) return;

      const modal = this.ensureModal();

      // Silence whatever the hover preview left running underneath.
      this.querySelectorAll('.vh-kol__video').forEach((other) => {
        other.pause();
        const otherCard = other.closest('[data-vh-kol-card]');
        if (otherCard) otherCard.classList.remove('is-previewing');
      });

      modal.hidden = false;
      modal.classList.toggle('has-steps', this.cards.length > 1);
      document.documentElement.classList.add('vh-kol-modal-open');

      this.placeClose();
      if (!this.phoneQuery) {
        this.phoneQuery = window.matchMedia('(max-width: 749px)');
        // Rotating a phone can cross the breakpoint mid-playback.
        this.phoneQuery.addEventListener('change', () => this.placeClose());
      }

      this.showCard(index);

      if (!this.keyBound) {
        this.keyBound = (event) => {
          if (event.key === 'Escape') this.closeModal();
          else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') this.stepClip(1);
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') this.stepClip(-1);
        };
        document.addEventListener('keydown', this.keyBound);
      }

      const dialog = modal.querySelector('.vh-kol__modal-inner');
      dialog.setAttribute('tabindex', '-1');
      dialog.focus();
    }

    // Swaps the clip in place. Only the video, the creator name and the shop row
    // change; the chrome around them is built once and stays put.
    showCard(index) {
      const card = this.cards[index];
      const source = card && card.querySelector('video');
      if (!source) return;

      this.index = index;

      const modal = this.modal;
      const stage = modal.querySelector('[data-stage]');
      const shop = modal.querySelector('[data-shop]');
      const creator = modal.querySelector('[data-creator]');
      const progress = modal.querySelector('[data-progress]');

      this.discardVideo();

      const video = document.createElement('video');
      video.className = 'vh-kol__modal-video';
      video.src = source.currentSrc || source.src;
      video.setAttribute('playsinline', '');
      video.playsInline = true;
      video.controls = false;
      video.loop = true;
      video.muted = false;
      stage.prepend(video);

      const name = card.dataset.vhKolName || '';
      creator.textContent = name;
      modal.querySelector('.vh-kol__modal-inner').setAttribute('aria-label', name || 'Video');

      const products = card.querySelector('[data-vh-kol-products]');
      if (products) {
        shop.replaceChildren(products.content.cloneNode(true));
        shop.hidden = false;
      } else {
        shop.replaceChildren();
        shop.hidden = true;
      }

      // Safe to bind per clip: the element is new each time and discarded on
      // the next swap, so nothing accumulates.
      ['play', 'playing', 'pause', 'ended', 'seeked'].forEach((type) => {
        video.addEventListener(type, () => {
          modal.classList.toggle('is-paused', video.paused);
          this.wake();
        });
      });

      video.addEventListener('timeupdate', () => {
        const ratio = video.duration ? video.currentTime / video.duration : 0;
        progress.style.transform = 'scaleX(' + ratio + ')';
      });

      modal.classList.toggle('is-paused', true);
      this.syncMute();
      this.wake();

      const played = video.play();
      if (played && played.catch) {
        played.catch(() => {
          // Sound refused before a gesture is registered on this element.
          // Falling back to muted playback beats showing a frozen frame.
          video.muted = true;
          this.syncMute();
          video.play().catch(() => {});
        });
      }
    }

    discardVideo() {
      const video = this.video;
      if (!video) return;
      video.pause();
      // Drop the src before discarding the node so the browser stops buffering
      // a clip nobody is watching any more.
      video.removeAttribute('src');
      video.load();
      video.remove();
    }

    closeModal() {
      if (!this.modal || this.modal.hidden) return;

      this.discardVideo();

      clearTimeout(this.idleTimer);
      this.modal.hidden = true;
      this.modal.classList.remove('is-idle', 'is-paused');
      document.documentElement.classList.remove('vh-kol-modal-open');

      if (this.keyBound) {
        document.removeEventListener('keydown', this.keyBound);
        this.keyBound = null;
      }
    }
  }

  if (!customElements.get('vh-kol-videos')) {
    customElements.define('vh-kol-videos', VhKolVideos);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vh-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  class StickyAtcBar extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-vh-sticky-add]');
      this.threshold = 240;
    }

    connectedCallback() {
      this.mainForm = document.querySelector('product-form form[data-type="add-to-cart-form"]');
      this.mainSubmit = document.querySelector('product-form .product-form__submit');

      if (this.button && this.mainSubmit) {
        this.button.addEventListener('click', this.onAdd.bind(this));
      }

      this.setupObserver();
      this.syncState();
    }

    setupObserver() {
      const target = this.mainSubmit || document.querySelector('.product-form__buttons');
      if ('IntersectionObserver' in window && target) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Show the bar once the main Add-to-cart button has scrolled out of view.
              this.toggle(!entry.isIntersecting);
            });
          },
          { rootMargin: '0px 0px -20% 0px', threshold: 0 }
        );
        this.observer.observe(target);
      } else {
        this.onScroll = () => this.toggle(window.scrollY > this.threshold);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
    }

    toggle(show) {
      if (show) {
        this.hidden = false;
        this.classList.add('vh-sticky-atc--visible');
      } else {
        this.classList.remove('vh-sticky-atc--visible');
        this.hidden = true;
      }
    }

    // Keep the sticky button's disabled/label + price in sync with the main form (variant switches).
    syncState() {
      if (!this.mainSubmit || !this.button) return;
      const update = () => {
        const disabled = this.mainSubmit.hasAttribute('disabled');
        this.button.disabled = disabled;
      };
      update();
      this.mainObserver = new MutationObserver(update);
      this.mainObserver.observe(this.mainSubmit, { attributes: true, attributeFilter: ['disabled'] });
    }

    onAdd(event) {
      event.preventDefault();
      if (this.button.disabled) return;
      // Delegate to the real product form so variant/quantity + cart drawer behaviour are inherited.
      if (this.mainSubmit) {
        this.mainSubmit.click();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.mainObserver) this.mainObserver.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }
  }

  if (!customElements.get('sticky-atc-bar')) {
    customElements.define('sticky-atc-bar', StickyAtcBar);
  }

  } catch(e) { console.error(e); }
})();
})();
